import React, { useRef } from 'react';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { Flex } from '@components/Flex';
import { aboutPageData } from '@data-ts/pages/about';
import {
  ColumnsDescription,
  StoryPersonImageWrapper,
  OurStoryColumns,
  OurStoryImageColumn,
  StyledStoriesPara,
  SignatureImage,
  OurStortImageContainer,
  StyledOurStoryImage1,
  StyledOurStoryImage2,
  StyledOurStoryImage3,
  StyledOurStoryImage4,
} from './OurStory.styles';
import { CloudImage } from '@components/CloudImage';

export const OurStory = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const { ourStory } = aboutPageData;
  return (
    <Box paddingTop={[11, 13]} paddingBottom={[13]}>
      <OurStoryColumns>
        <OurStoryImageColumn width={6}>
          <OurStortImageContainer>
            <StyledOurStoryImage1 src="about-us/story-1.jpg" alt="our story 1" optimization="mild" />
            <StyledOurStoryImage2 src="about-us/story-2.jpg" alt="our story 2" optimization="mild" />
            <StyledOurStoryImage3 src="about-us/story-3.jpg" alt="our story 3" optimization="mild" />
            <StyledOurStoryImage4 src="about-us/story-4.jpg" alt="our story 4" optimization="mild" />
          </OurStortImageContainer>
        </OurStoryImageColumn>
        <ColumnsDescription width={6}>
          <Text variant="sectionEyeBrow24" tagName="p" color="yellow5" marginBottom={[6, 7]}>
            {ourStory.title}
          </Text>
          {ourStory.stories.map((item, index) => (
            <StyledStoriesPara key={index} variant="dek20" tagName="p" color="neutra6" marginBottom={[5]}>
              {item}
            </StyledStoriesPara>
          ))}
          <Text variant="dek20" tagName="p">
            {ourStory.sincerely}
          </Text>
          <Box marginY={[6]}>
            <SignatureImage src="about-us/vishal-joshi-signature.png" />
          </Box>
          <Flex alignItems="center">
            <StoryPersonImageWrapper>
              <CloudImage src="about-us/vishal-avatar.jpg" alt="story person image" width="100%" height="100%" />
            </StoryPersonImageWrapper>
            <Box paddingLeft={[4, 4]}>
              <Text variant="featureHed17" tagName="span" color="neutra6">
                {`${ourStory.storyPerson}, ${ourStory.designation}`}
              </Text>
            </Box>
          </Flex>
        </ColumnsDescription>
      </OurStoryColumns>
    </Box>
  );
};
